import useFetch from "../../global/hooks/useFetch";
import useMutation from "../../global/hooks/useMutation";

export const useAssets = (
  page = 1,
  pageSize = 12,
  search = "",
  assetType = "",
  unassigned = false,
) => {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : "";
  const typeParam = assetType ? `&asset_type=${assetType}` : "";
  const unassignedParam = unassigned ? "&unassigned=true" : "";
  const { data, loading, refetch } = useFetch(
    `/assets/?page=${page}&page_size=${pageSize}${searchParam}${typeParam}${unassignedParam}`,
  );
  const {
    mutate: createAssetMutation,
    loading: creating,
    error,
  } = useMutation("/assets/", "POST");

  const createAsset = async (asset) => {
    const createdAsset = await createAssetMutation(asset);
    await refetch();
    return createdAsset;
  };

  if (error) {
    console.log(error.message);
  }

  return {
    assets: data?.results || [],
    pagination: {
      count: data?.count || 0,
      next: data?.next,
      previous: data?.previous,
    },
    loading,
    createAsset,
    creating,
    error,
    refetch,
  };
};

export const useLinkEpisodes = () => {
  const {
    mutate,
    loading: linking,
    error: linkError,
  } = useMutation("/assets/link-episodes/", "POST");

  const linkEpisodes = async (seriesId, episodeIds) => {
    return mutate({ series_id: seriesId, episode_ids: episodeIds });
  };

  return { linkEpisodes, linking, linkError };
};
